import styled, { css } from 'styled-components';

import { floorGameColor, styledTypography } from '@pkg/primitives';

export enum Variants {
    primary = 'primary',
    secondary = 'secondary',
}

type Variant = `${Variants}`;

type Props = {
    $variant: Variant;
};

export const StyledIndicator = styled.div<Props>`
    border: 2px solid ${floorGameColor.black};
    background: ${({ theme, $variant }) =>
        $variant === Variants.secondary ? theme.colors.purple : theme.colors.white};
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    display: flex;
    height: 20px;
    width: 20px;

    span {
        ${styledTypography.allianceBase};
        color: ${({ theme, $variant }) => ($variant === Variants.secondary ? theme.colors.white : theme.colors.black)};
        font-weight: 700;
        font-size: 10px;
        line-height: 1;
    }

    ${({ theme }) => {
        return css`
            @media (max-width: ${theme.breakpoints.mobile}) {
                border: none;
                height: 13px;
                width: 13px;
                span {
                    font-size: 8px;
                }
            }
        `;
    }}
`;
